import { Component, OnInit, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DisneyService, SearchStateService } from '@core/services';
import { IDisneyClusterMeals } from '@core/models/modals';
import { MbDialogRef, MB_DIALOG_DATA, MbDialogHeader, MbDialogBody, MbIconModule, MbButton } from '@am/moebius';
import { DialogWrapperComponent } from '@modals/dialog-wrapper/dialog-wrapper.component';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'app-modal-disney-cluster-meals-info',
  standalone: true,
  imports: [CommonModule, MbDialogHeader, MbDialogBody, MbIconModule, MbButton, SharedModule],
  templateUrl: './disney-cluster-meals-info.component.html',
  styleUrls: ['./disney-cluster-meals-info.component.scss'],
})
export class ModalDisneyClusterMealsInfoComponent
  extends DialogWrapperComponent
  implements OnInit
{
  public toggleStatus: any[];
  public filteredRates: any;
  public quantityGuests: number;

  constructor(
    private disneyService: DisneyService,
    private searchStateService: SearchStateService,
    private dialogRef: MbDialogRef<ModalDisneyClusterMealsInfoComponent>,
    @Inject(MB_DIALOG_DATA) public dialogData: IDisneyClusterMeals,
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    const decodedRooms = this.searchStateService.getDecodedRooms();
    this.toggleStatus = new Array(this.dialogData.mealPlans.length);
    this.quantityGuests = decodedRooms.total;

    // Filter meal plans by selected ticket
    this.filteredRates = {
      DISNEY_QUICK_DINING: {},
      DISNEY_DINING: {},
      DISNEY_DELUXE: {},
    };
    this.dialogData.mealPlans.forEach((meal) => {
      if (meal.code !== 'ROOM_ONLY') {
        if (!this.dialogData.selectedTicket) {
          this.filteredRates[meal.code] = { mealPlan: meal, rate: meal.rates[0] };
        } else {
          let ticketRate;
          meal.rates.forEach((rate) => {
            if (
              this.getRateSupplement(rate, 'TICKET') &&
              this.getRateSupplement(rate, 'MEAL')
            ) {
              if (
                this.getRateSupplement(rate, 'TICKET').id ===
                this.dialogData.selectedTicket
              ) {
                ticketRate = rate;
              }
            }
          });
          if (ticketRate) {
            this.filteredRates[meal.code] = { mealPlan: meal, rate: ticketRate };
          }
        }
      }
    });
  }

  public descOrder(a, b) {
    if (a.key < b.key) {
      return b.key;
    }
  }

  public closeDialog(mealPlan?: any) {
    this.dialogRef.close(mealPlan);
  }

  public isMealPlanFree(rate) {
    return this.disneyService.isMealPlanFree(rate);
  }

  public getRateSupplement(rate, supplementType) {
    return this.disneyService.getRateSupplement(rate, supplementType);
  }

  public toggle(index) {
    this.toggleStatus[index] = !this.toggleStatus[index];
  }
}
